const template = `
<div>
  <div id="app" class="ok-filter-search -mb-article">
    <input type="hidden" name="find_val" value="">
    <input type="hidden" name="main_words" value="Все разделы,От,До,Ключевая фраза,Цена (руб.),Товары,В наличии,В разделе,Любое значение,Подобрать,Очистить,Сравнить,Сортировка,Показывать по,Без сортировки,По возрастанию цены,По убыванию цены,По названию от А до Я,По названию от Я до А">
    <template v-if="loading">
      Loading...
    </template>
    <template v-else>
      <template v-if="!urlValue">
        <template v-if="!isNewGroup">
         <app-status-razdel :sp="sp" :jsonval="jsonval" @fstatus="fstatus" @putSpToApp="hideRazdel=!hideRazdel" @spvalue="spvalue"></app-status-razdel>
         <app-all-razdel :posts="orders" :jsonval="jsonval" @putHideRazdelToApp="hideAndChangeSp" @putHideDefault="hideDefaultSp" v-show="hideRazdel"></app-all-razdel>
       </template>
       <div class="f-color-grey-hover -mb-article-half -mt-article-half">
         <form @submit.prevent="pageButton(1)" class="page-find-form" ref="formRef" accept-charset="windows-1251">
           <input type="hidden" data-id="main_course" value="10000">
           <input type="hidden" data-id="course" value="10000">
           <input type="hidden" name="charset" :value="charset">
           <app-fisrt-find-block :findVal="findVal" v-show="affb" :jsonval="jsonval"></app-fisrt-find-block>
           <template v-if="groupid !== 0">
             <template v-if="loadingElement">
               loading...
             </template>
             <template v-else>
             <app-options :opt="ordersElement" :groupid="groupid" :jsonval="jsonval" v-show="showOptions"></app-options>
             </template>
           </template>
           <app-find-button v-show="afb" :jsonval="jsonval"></app-find-button>
         </form>
       </div>
      </template>
      <template v-else>
        <template v-if="!isNewGroup">
          <app-status-razdel :sp="sp" :jsonval="jsonval" @fstatus="fstatus" @putSpToApp="hideRazdel=!hideRazdel" @spvalue="spvalue"></app-status-razdel>
          <app-all-razdel :posts="orders" :jsonval="jsonval" @putHideRazdelToApp="hideAndChangeSp" @putHideDefault="hideDefaultSp" v-show="hideRazdel"></app-all-razdel>
        </template>
        <div class="f-color-grey-hover -mb-article-half -mt-article-half">
          <form @submit.prevent="pageButton(1)" class="page-find-form" ref="formRef" accept-charset="windows-1251">
            <input type="hidden" data-id="main_course" value="10000">
            <input type="hidden" data-id="course" value="10000">
           <input type="hidden" name="charset" :value="charset">
            <app-fisrt-find-block :findVal="findVal" v-show="affb" :jsonval="jsonval"></app-fisrt-find-block>
            <template v-if="groupid !== 0">
              <template v-if="loadingElement">
                loading...
              </template>
              <template v-else>
                <app-options :opt="ordersElement" :groupid="groupid" :jsonval="jsonval" v-show="showOptions"></app-options>
              </template>
            </template>
            <app-find-button v-show="afb" :jsonval="jsonval"></app-find-button>
          </form>
        </div>
      </template>
    </template>
    <template v-if="product_count > 0">
      <div class="ok-filters-box ok-filters-sort">
        <div class="ok-filters-box__left">
          <div class="ok-btn-group">
            <div class="ok-select ok-select__section-filter">
              <div class="ok-select__inner dropdown -search-dropdown">
                <select class="form-control" data-ok-select="" name="sort" v-model="singlesel" style="display: none">
                  <option value="1" selected="selected">{{jsonval.noSort}}</option>
                  <option value="2">{{jsonval.priceUp}}</option>
                  <option value="3">{{jsonval.priceDown}}</option>
                  <option value="3">{{jsonval.wordsUp}}</option>
                  <option value="3">{{jsonval.wordsDown}}</option>
                </select>
                <button type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="form-control">{{ singlesel }}<i class="fa fa-angle-down pull-right f-color-grey"></i></button>
                <ul class="dropdown-menu" data-select="sort">
                  <li><a href="#app" data-value="1" @click.prevent="sortButton('')">{{jsonval.noSort}}</a></li>
                  <li><a href="#app" data-value="2" @click.prevent="sortButton('price__number')">{{jsonval.priceUp}}</a></li>
                  <li><a href="#app" data-value="3" @click.prevent="sortButton('price__number__desc')">{{jsonval.priceDown}}</a></li>
                  <li><a href="#app" data-value="4" @click.prevent="sortButton('name__text')">{{jsonval.wordsUp}}</a></li>
                  <li><a href="#app" data-value="5" @click.prevent="sortButton('name__text__desc')">{{jsonval.wordsDown}}</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="ok-filters-box__center">
        </div>
        <div class="ok-filters-box__right">
          <div class="ok-btn-group">
            <label class="control-label">{{jsonval.pageSize}}:</label>
            <div class="ok-select ok-select__section-filter">
              <div class="ok-select__inner dropdown -search-dropdown">
                <select class="form-control" data-ok-select="" name="limit" v-model="page_size" style="display: none">
                  <option :value="1" selected="selected">12</option>
                  <option :value="2">24</option>
                  <option :value="3">48</option>
                </select>
                <button type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="form-control">{{ page_size }}<i class="fa fa-angle-down pull-right f-color-grey"></i></button>
                <ul class="dropdown-menu" data-select="limit">
                  <li><a href="#app" :data-value="1" @click.prevent="sizeButton(12)">12</a></li>
                  <li><a href="#app" :data-value="2" @click.prevent="sizeButton(24)">24</a></li>
                  <li><a href="#app" :data-value="3" @click.prevent="sizeButton(48)">48</a></li>
                </ul>
              </div>
            </div>
          </div>
          <a href="#app" class="ok-btn -btn-width-small -btn-grid -state-active ok-btn__filters">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10"><path data-name="Rounded Rectangle 917 copy 3" class="cls-1" d="M1566,603h1a1,1,0,0,1,0,2h-1A1,1,0,0,1,1566,603Zm5,0h1a1,1,0,0,1,0,2h-1A1,1,0,0,1,1571,603Zm5,0h1a1,1,0,0,1,0,2h-1A1,1,0,0,1,1576,603Zm-10,4h1a1,1,0,0,1,0,2h-1A1,1,0,0,1,1566,607Zm5,0h1a1,1,0,0,1,0,2h-1A1,1,0,0,1,1571,607Zm5,0h1a1,1,0,0,1,0,2h-1A1,1,0,0,1,1576,607Zm-10,4h1a1,1,0,0,1,0,2h-1A1,1,0,0,1,1566,611Zm5,0h1a1,1,0,0,1,0,2h-1A1,1,0,0,1,1571,611Zm5,0h1a1,1,0,0,1,0,2h-1A1,1,0,0,1,1576,611Z" transform="translate(-1565 -603)"></path></svg>
          </a>
          <a href="#app" class="ok-btn -btn-width-small -btn-list ok-btn__filters">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10"><path data-name="Rounded Rectangle 917" class="cls-1" d="M1594,603h1a1,1,0,0,1,0,2h-1A1,1,0,0,1,1594,603Zm5,0h6a1,1,0,0,1,0,2h-6A1,1,0,0,1,1599,603Zm-5,4h1a1,1,0,0,1,0,2h-1A1,1,0,0,1,1594,607Zm5,0h6a1,1,0,0,1,0,2h-6A1,1,0,0,1,1599,607Zm-5,4h1a1,1,0,0,1,0,2h-1A1,1,0,0,1,1594,611Zm5,0h6a1,1,0,0,1,0,2h-6A1,1,0,0,1,1599,611Z" transform="translate(-1593 -603)"></path></svg>
          </a>
        </div>
      </div>
    </template>
    <div :style="contentStyle" v-html="testhtml"></div>
    <template v-if="product_count > 0">
      <div class="ok-filters-box ok-filter-pagination clearfix -mb-article">
        <div class="ok-filters-box__center">
          <div class="ok-btn-group">
            <template v-if="page_num > 1">
              <a href="#app" class="ok-btn ok-fl-pag__prev" @click.prevent="pageButton(page_num - 1)"></a>
            </template>
            <template v-if="page_product_count <= 5">
              <!__Первый вид до пяти элементов__>
              <template v-for="i in page_product_count">
                <a href="#app" class="ok-btn" :class="isActivePage(i)" @click.prevent="pageButton(i)">{{ i }}</a>
              </template>
            </template>
            <template v-if="page_product_count > 5">
              <!__Второй вид более пяти элементо №1 в__>
              <template v-if="(page_num + step < page_product_count && page_num - step <= 1)">
                <template v-for="i in page_num + step">
                  <a href="#app" class="ok-btn" :class="isActivePage(i)" @click.prevent="pageButton(i)">{{ i }}</a>
                </template>
                <span class="-btn-width-small">...</span>
                <a href="#app" class="ok-btn" @click.prevent="pageButton(page_product_count)" :class="isActivePage(page_product_count)">{{ page_product_count }}</a>
              </template>
              <!__Второй вид более пяти элементо №2 в__>
              <template v-if="(page_num + step < page_product_count && page_num - step > 1)">
                <a href="#app" class="ok-btn" @click.prevent="pageButton(1)">1</a>
                <span class="-btn-width-small">...</span>
                <template v-for="i in page_num + step" v-if="i >= page_num - step">
                  <a href="#app" class="ok-btn" :class="isActivePage(i)" @click.prevent="pageButton(i)">{{ i }}</a>
                </template>
                <span class="-btn-width-small">...</span>
                <a href="#app" class="ok-btn" @click.prevent="pageButton(page_product_count)">{{ page_product_count }}</a>
              </template>
              <!__Второй вид более пяти элементо №3 в__>
              <template v-if="page_num + step >= page_product_count">
                <a href="#app" class="ok-btn" @click.prevent="pageButton(1)">1</a>
                <span class="-btn-width-small">...</span>
                <template v-for="i in page_product_count" v-if="i >= page_product_count - 4">
                  <a href="#app" class="ok-btn" :class="isActivePage(i)" @click.prevent="pageButton(i)">{{ i }}</a>
                </template>
              </template>
            </template>
            <template v-if="page_num != page_product_count">
              <a href="#app" class="ok-btn ok-fl-pag__next" @click.prevent="pageButton(page_num + 1)"></a>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</div>`


export default template



// WEBPACK FOOTER //
// ./src/components/templates/45/App.js